import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SelectFilterMovies from './SelectFilterMovies';

class FilterMoviesComponent extends Component {

    constructor(props) {
        super(props);
        let queryParam = props.getParamUrl ? props.getParamUrl : '';

        this.state = {
            formFilter: queryParam.form ? queryParam.form : '',
            languagesFilter: queryParam.languages ? queryParam.languages : '',
            kindFilter: queryParam.kind ? queryParam.kind : '',
            nationsFilter: queryParam.nation ? queryParam.nation : '',
        }
    }

    showDataFilter = datas => {
        let result = null;
        if (datas.length) {
            result = datas.map((data, index) => {
                return (
                    <option key={ index } value={ data._id }>{ data.name }</option>
                );
            });
        }
        return result;
    }

    onChangeFilter = (param) => {
        let target = param.target;
        let name   = target.name;
        let value  = target.value;
        this.setState({
            [name]: value,
        });
    }

    render() {

        let { categoriesForm, categoriesKind, languages, nations } = this.props;
        let {formFilter, languagesFilter, kindFilter, nationsFilter } = this.state;
        let url = `?form=${formFilter}&languages=${languagesFilter}&kind=${kindFilter}&nation=${nationsFilter}`;

        return (
            <div className="block-select-movie container clearfix">
                <div className="content">
                    {/* Hinh thuc */}
                    <SelectFilterMovies
                        dataFilter={categoriesForm}
                        defaultDisplay="Hình thức"
                        valueFilter={formFilter}
                        nameFilter="formFilter"
                        onChangeFilter={ this.onChangeFilter }
                    />

                    {/* Ngon ngu */}
                    <SelectFilterMovies
                        dataFilter={languages}
                        defaultDisplay="Ngôn ngữ"
                        valueFilter={languagesFilter}
                        nameFilter="languagesFilter"
                        onChangeFilter={ this.onChangeFilter }
                    />

                    {/* The loai */}
                    <SelectFilterMovies
                        dataFilter={categoriesKind}
                        defaultDisplay="Thể loại"
                        valueFilter={kindFilter}
                        nameFilter="kindFilter"
                        onChangeFilter={ this.onChangeFilter }
                    />

                    {/* Quoc gia */}
                    <SelectFilterMovies
                        dataFilter={nations}
                        defaultDisplay="Quốc gia"
                        valueFilter={nationsFilter}
                        nameFilter="nationsFilter"
                        onChangeFilter={ this.onChangeFilter }
                    />
                    <Link
                        to={{
                            pathname: '/trang-phim/filter',
                            search: url
                        }}
                        replace={ true }
                        className="sbm"
                    >
                    Duyệt phim
                    </Link>
                </div>
            </div>
        );
    }

}

export default FilterMoviesComponent;



// WEBPACK FOOTER //
// ./src/components/MoviePageComponent/FilterOptionsComponent.js